export const getActiveBetClasses = (isGameFinished: boolean, amIWinner: boolean) => {
  const wrapperClass = isGameFinished
    ? `bg-gradient-to-b from-[#FFF] ${amIWinner ? 'to-[#FFC000]' : 'to-[#E81C34]'}`
    : 'bg-gradient-to-b from-[#FFF] to-[#4FB5FF]';

  const innerClass = isGameFinished
    ? `bg-gradient-to-t ${amIWinner ? 'from-[#250A02] to-[#AA6900]' : 'from-[#020C25] to-[#901826]'}`
    : 'bg-gradient-to-t from-[#00011D] to-[#00079C]';

  return { wrapperClass, innerClass };
};
